import { render, staticRenderFns } from "./JoszakiTextArea.vue?vue&type=template&id=20268507"
import script from "./JoszakiTextArea.vue?vue&type=script&lang=js"
export * from "./JoszakiTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports